import SectorEdit from './SectorEdit';
import SectorList from './SectorList';

export default {
  name: 'sector',
  edit: SectorEdit,
  list: SectorList,
};
